import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  List,
  ListItem,
  DialogActions,
  ListItemIcon,
  Button,
} from "@mui/material";
import { useLoader } from "../../context/LoaderContext";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  ReprocessDownStream,
  ReprocessEdelivery,
} from "../../api/downstreamSummaryApi/downstreamSummaryApi";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

interface DownstreamFDReprocesspopupProps {
  isOpen: boolean;
  onClose: (isCancelClick: boolean) => void;
  title: string;
  selectedData: any;
  value: number;
}

const DownstreamFDReprocesspopup: React.FC<DownstreamFDReprocesspopupProps> = ({
  isOpen,
  onClose,
  title,
  selectedData,
  value,
}) => {
  const { setLoading } = useLoader();
  const { showSnackbar } = useSnackbar();

  const handleYes = async () => {
    try {
      setLoading(true);
      //Repocess-Send to preflight,E-Delivery reprocess and send to downsample
      let params = selectedData.map((data: any) => {
        return {
          FileName: data.FileName,
          processType: data.ProcessType,
          DocumentStreamId: data.DocumentStreamId,
          accountId: Number(LocalStorageUtil.getItem("accountId")),
          userId: Number(LocalStorageUtil.getItem("userId")),
          contextName: LocalStorageUtil.getItem("contextName"),
        };
      });
      if (value === 1) {
        const response = await ReprocessDownStream(params);
        console.log("ReprocessDownStream Response:", response);
        showSnackbar("Documents Reprocessed successfully");
        onClose(true);
      } else {
        const response = await ReprocessEdelivery(params);
        console.log("ReprocessEdelivery Response:", response);
        showSnackbar("Documents Reprocessed successfully");
        onClose(true);
      }
    } catch (error) {
      console.log("Error in Reprocess Sub System. Please try again.");
    } finally {
      handleDialogClose(false);
      setLoading(false);
    }
  };
  const handleDialogClose = (confirm: boolean) => {
    onClose(false);
  };
  return (
    <Dialog open={isOpen} onClose={() => handleDialogClose(false)}>
      <DialogTitle
        style={{
          backgroundColor: "var(--primary-color)",
                  color: "var(--aggrid-text-color)",
                  fontSize: "16px", 
                  fontWeight: 500, 
                  padding: "12px 16px", 
                  display: "flex",
                  alignItems: "center",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent style={{ fontSize: "12px", marginTop: "20px",  padding: "1px 24px"}}>
        <DialogContentText>
          <List>
            {selectedData.map((data: any, i: number) => (
              <ListItem
                key={data.DocumentStreamId || data.FileName}
                sx={{ fontSize: "12px", margin: "2px 0", padding: "1px 1px" }}
              >
                <ListItemIcon sx={{ minWidth: "10px" }}>
                  <FiberManualRecordIcon sx={{ fontSize: "8px" }} />
                </ListItemIcon>
                {data.FileName}
              </ListItem>
            ))}
          </List>
          <div style={{ fontSize: "11px", margin: "1em" }}>
            Are you sure you want to proceed?
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleYes}
          style={{
            textTransform: "none",
            borderRadius: "0px",
            backgroundColor: "var(--button-background-color)",
            color: "var(--button-color)",
            fontSize: "11px",
            padding: "5px 12px",
            border: "1px solid #144979",
            margin: "0 5px 5px 5px",
            whiteSpace: "white-space",
            height: "3.5vh",
          }}
          autoFocus
        >
          Ok
        </Button>
        <Button
          onClick={() => handleDialogClose(false)}
          style={{
            textTransform: "none",
            borderRadius: "0px",
            backgroundColor: "var(--button-background-color)",
            color: "var(--button-color)",
            fontSize: "11px",
            padding: "5px 12px",
            border: "1px solid #144979",
            margin: "0 5px 5px 5px",
            whiteSpace: "white-space",
            height: "3.5vh",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownstreamFDReprocesspopup;
